import React from 'react';
import { CalendarIcon, PhoneIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { ButtonLink } from './ButtonLink';
import { business, images, preOwnedSpecs } from '../data/site';
export function PreOwned() {
  return <section id="pre-owned" aria-labelledby="preowned-title" className="gutter section-y w-full scroll-mt-24 bg-sand" data-id="element-245" data-mp="3dft4vnyfprqq">
      <h2 id="preowned-title" className="display text-[clamp(2.5rem,5vw,5.5rem)] font-extrabold text-navy" data-id="element-246" data-mp="38jvnrffckhcw">
        Pre-Owned
      </h2>
      <Reveal className="mt-10" data-id="element-247" data-mp="2ftdqww57vc7x">
        <article className="grid overflow-hidden rounded-xl bg-white lg:grid-cols-[1.5fr_1fr]" data-id="element-248" data-mp="2fuf0sxahxso2">
          <div className="relative aspect-[16/10] lg:aspect-auto lg:min-h-[520px]" data-id="element-249" data-mp="2tu6lfgviq7b1">
            <img src={images.preOwned} alt="2007 Hurricane 237 Sundeck deck boat on a LoadRite aluminum trailer" loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-250" data-mp="2ppywbil5epca" />
            <span className="absolute left-4 top-4 rounded bg-water px-3 py-1.5 text-xs font-bold uppercase tracking-wide text-navy-950" data-id="element-251" data-mp="1sqo1mlvwcab1">
              Available now
            </span>
          </div>
          <div className="flex flex-col p-6 md:p-10 3xl:p-14" data-id="element-252" data-mp="21rcdpb1qc0la">
            <p className="text-sm font-semibold text-ink-soft" data-id="element-253" data-mp="21rvpea0sdsqv">2007 · Deck boat · 23 ft</p>
            <h3 className="display mt-2 text-4xl font-bold text-navy md:text-5xl" data-id="element-254" data-mp="26px3shn9p3w0">2007 Hurricane 237 Sundeck</h3>
            <p className="display mt-4 text-5xl font-extrabold text-ink md:text-6xl" data-id="element-255" data-mp="1a20uzyy2ncvc">$16,500</p>
            <p className="mt-4 text-ink-muted" data-id="element-256" data-mp="1e21azo0tjw4i">
              Yamaha F225TXR with only 140 hours. Includes LoadRite aluminum trailer.
            </p>
            <dl className="mt-6 divide-y divide-navy/10 border-y border-navy/10" data-id="element-257" data-mp="1ns4dcettymfi">
              {preOwnedSpecs.map(s => <div key={s.label} className="flex justify-between gap-4 py-3 text-[15px]" data-id="element-258" data-mp="qbfdurscrw9a">
                  <dt className="text-ink-soft" data-id="element-259" data-mp="va8hztlr2aws">{s.label}</dt>
                  <dd className="text-right font-semibold text-ink" data-id="element-260" data-mp="1ym7egq2amfnz">{s.value}</dd>
                </div>)}
            </dl>
            <div className="mt-auto flex flex-col gap-2 pt-8 sm:flex-row" data-id="element-261" data-mp="1tm1mt9w0wt5w">
              <ButtonLink href="#contact" className="flex-1" data-id="element-262" data-mp="27f0z730ie798">
                <CalendarIcon className="h-4 w-4" aria-hidden="true" data-id="element-263" data-mp="27glskpb37k5i" />
                Arrange a Viewing
              </ButtonLink>
              <ButtonLink href={business.tel} variant="outline" data-id="element-264" data-mp="1fn1uns9axw4z">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-265" data-mp="1fpfra5jmrgen" />
                {business.phone}
              </ButtonLink>
            </div>
          </div>
        </article>
      </Reveal>
    </section>;
}